import React, { useState, useEffect, useContext } from "react";
import HeroSection from "../components/HeroSection";
import { Container, Box, Button } from "@mui/material";
import img from "../assets/img.png";
import { Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import WeCear from "../components/WeCear";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import Footer from "../components/Footer";
import ImagesLogo from "../components/ImagesLogo";
import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Zoom, Navigation, Pagination } from "swiper/modules";
import { serviceCard00 } from "../assets/data";
import Lottie from "react-lottie";
import animationData from "../assets/a1.json";
import { AppContext } from "../context/ContenxtAPI";

const CardsSlider = ({ serviceCard, id }) => {
  const handleFindOutMore = (id) => {
    serviceCard(id);
    console.log("id is :", id);
  };

  return (
    <div>
      <Swiper
        zoom={true}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        modules={[Zoom, Navigation, Pagination]}
        spaceBetween={30}
        className="mySwiper"
      >
        {serviceCard.map((item, i) => (
          <SwiperSlide key={i}>
            <div className="one_services">
              <h2 className="card_btn1">
                <span className="cardspan">{item.caption}</span>
              </h2>
              {i === 2 ? (
                <div className="best_seller_div">
                  <p>Best Seller</p>
                </div>
              ) : null}
              <div
                className="cards_staps"
                style={{ marginBottom: i === 2 ? "6.5rem" : "" }}
              >
                <div>
                  <div className="card_titles">
                    <h1>{item.title}</h1>
                    <p>{item.caption}</p>
                  </div>
                  <div className="cards_price">
                    <h1>{item.price}</h1> p/m
                  </div>
                  <div className="cards_actions mt">
                    <div className="cards_actions">
                      {item.working.map((item, i) => (
                        <div className="working" key={i}>
                          <CheckCircleOutlineRoundedIcon
                            style={{ color: "#604CD4" }}
                          />
                          {item}
                        </div>
                      ))}
                    </div>
                    <div className="cards_actions">
                      {item?.notworking?.map((item, i) => (
                        <div className="notwarking" key={i}>
                          <CancelOutlinedIcon
                            style={{ color: "#604CD4", opacity: "0.6" }}
                          />
                          <span className="spanundesr">{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div>
                  <Link to={`/FindOutMore/${item.id}`}>
                    <Button
                      variant="contained"
                      className="card_btn"
                      onClick={() => handleFindOutMore(item.id)}
                    >
                      Find Out More
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const titles = {
  title: (
    <>
      WeCare about
      <br /> your boiler, your home
      <br /> and about you!
    </>
  ),
};

const OneOffServices = () => {
  const match140 = useMediaQuery("(max-width:480px)");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [offServicescards, setOffServicescards] = useState([]);
  const { boilerService } = useContext(AppContext);
  const [showAnimation, setShowAnimation] = useState(true);
  const handleFindOutMore = (id) => {
    setOffServicescards(id);
    console.log("id is :", id);
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  useEffect(() => {
    setOffServicescards(serviceCard00);
    boilerService();
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <HeroSection title={titles} />
      <Container maxWidth="xl" className="containers">
        <Box className="flexDivs">
          <Box className="sec2div">
            <p className="second_titles_home">
              At WeCare, we understand the <br /> importance of a warm, safe,
              and <br />
              well-maintained home. As a leading <br /> provider of boiler
              repair and home <br /> care services, we take pride in being{" "}
              <br /> your trusted partner in ensuring <br /> your home remains
              comfortable <br /> and secure, all year round.
            </p>
            <Link to="/About" style={{ display: match140 ? "none" : "flex" }}>
              {" "}
              <Button variant="contained" className="herobtn">
                Read Our Story
              </Button>
            </Link>
          </Box>
          <Box className="imgdiv">
            <img src={img} alt="" />
          </Box>
          <Link to="/About" style={{ display: match140 ? "flex" : "none" }}>
            {" "}
            <Button variant="contained" className="herobtn">
              Read Our Story
            </Button>
          </Link>
        </Box>
      </Container>
      <Box className="containers">
        <WeCear />
      </Box>
      {showAnimation ? (
        <div className="center-animation" id="boilerServices">
          <Lottie options={defaultOptions} height={400} width={400} />
        </div>
      ) : (
        <div
          className="pb-5 oneOffService"
          style={{ zIndex: 0, position: "relative" }}
        >
          <div className="servece_text_div" id="boilerServices">
            <h1>
              <span>WeCare,</span> Annual Boiler Service
            </h1>
            <p>
              With WeCare, the power of choice is in your hands. Whether you
              prefer a monthly or yearly payment plan, it's entirely up to you.
              Additionally, if you're a landlord, you have the option to secure
              an annual boiler service policy along with the CP12 certificate.
            </p>
          </div>
          <div className="main_cards_stap_boiler">

            {offServicescards.map((item, i) => (
              <>
                
                <div className="cards_staps" style={{position: "relative"}} key={i}>
                <div>
                  <h2 className="card_btn1">
                    <span className="cardspan">{item.caption}</span>
                  </h2>
                  {i === 2 ? (
                    <div className="best_seller_div">
                      <p>Best Seller</p>
                    </div>
                  ) : null}
                </div>
                  <div className="Card_Content_Top">
                    <div className="card_titles">
                      <h1>{item.title}</h1>
                      <p>{item.caption}</p>
                    </div>
                    <div className="cards_price">
                      <h1>{item.price}</h1>
                      {i !== 1 && <span></span>}
                    </div>
                    <div className="cards_actions mt">
                      <div className="cards_actions">
                        {item.working.map((item, i) => (
                          <div className="working" key={i}>
                            <CheckCircleOutlineRoundedIcon
                              style={{ color: "#604CD4" }}
                            />
                            {item}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="Card_Button_Down">
                    <Link
                      to={`/OneOffRepair/${item.id}`}
                      style={{ marginTop: "auto" }}
                    >
                      <Button
                        variant="contained"
                        className="card_btn"
                        onClick={() => handleFindOutMore(item.id)}
                      >
                        Find Out More
                      </Button>
                    </Link>
                  </div>
                </div>
              </>


            ))}
          </div>
        </div>
      )}
      <Box className="maincenter">
        <h1 className="its_h1">
          It’s simple and easy to switch
          <br /> your home plan to us today!
        </h1>
        <Link to="/BookRepair">
          <Button variant="contained" className="herobtn">
            Get a Quote
          </Button>
        </Link>
      </Box>
      <div>
        <ImagesLogo />
      </div>
      <Footer />
    </>
  );
};

export default OneOffServices;
